import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import useFormHook from "@shared/hooks/useFormHook";
import { identificatorsService } from "@modules/additionalSettings/nomenclatures/services/identificators";
import { notifySuccess, notifyError } from "@config/tostifyConfig/tostifyConfig";

export default function IndentificatorForm({ onClose, determ = null, modalType = 'add', onSuccess }) {
    const { modalRef } = useFormHook({}, onClose);
    const { t } = useTranslation();
    const { register, handleSubmit, setValue, reset } = useForm();
    const [isActiveChecked, setIsActiveChecked] = useState(false);
    const [loading, setLoading] = useState(false);

    // Initialize form with data if editing
    useEffect(() => {
        if (determ && modalType === 'edit') {
            setValue('totalValue', determ.sizeDet);
            setValue('code', determ.mnemonic);
            setValue('title', determ.note);
            setValue('typeOfIdentificator', determ.typeDet ? '3' : '2'); // 3 for Tree, 2 for Linear
            setValue('active', determ.active);
            setIsActiveChecked(determ.active);
        }
    }, [determ, modalType, setValue]);

    const submitForm = async (data) => {
        setLoading(true);
        try {
            if (modalType === 'add') {
                await identificatorsService.createDeterm(data);
                notifySuccess(t('common.createdSuccessfully'));
            } else {
                await identificatorsService.updateDeterm(determ.id, data);
                notifySuccess(t('common.updatedSuccessfully'));
            }
            
            if (onSuccess) {
                onSuccess();
            }
            onClose();
        } catch (error) {
            console.error('Error submitting form:', error);
            notifyError(error?.response?.data?.message || t('common.errorOccurred'));
        } finally {
            setLoading(false);
        }
    }

    const handleClose = (e) => {
        if (modalRef.current === e.target) {
            onClose();
        }
    }

    const handleIsActiveChange = (e) => {
        setIsActiveChecked(e.target.checked);
        setValue('active', e.target.checked);
    }

    return (
        <div className="modal show" tabIndex="-1" onClick={handleClose}>
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {modalType === 'add' ? t('common.add') : t('common.edit')} {t('additionalSettings.identificators.title')}
                        </h4>
                        <form id="indentificatorForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="flex-column">
                                <div className="form-section">
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.totalValue')} <span className="required">*</span></span>
                                        <input type="text" className="form-control" {...register('totalValue', { required: true, min: 1 })} />
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.code')} <span className="required">*</span></span>
                                        <input type="text" className="form-control" {...register('code', { required: true })} />
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.title')} <span className="required">*</span></span>
                                        <input type="text" className="form-control" {...register('title', { required: true })} />
                                    </div>
                                    <div className="form-group">
                                        <span className="span-bold">{t('additionalSettings.identificators.form.nomenclatureType')}</span>
                                        <select className="form-control" {...register('typeOfIdentificator', { required: true })}>
                                            <option value="2">{t('additionalSettings.identificators.form.linear')}</option>
                                            <option value="3">{t('additionalSettings.identificators.form.tree')}</option>
                                        </select>
                                    </div>
                                    <div className="flex-row">
                                        <span className="span-bold">
                                            {t('additionalSettings.identificators.form.active')}
                                        </span>
                                        <div className="input-checkbox-wrapper">
                                            <input
                                                type="checkbox"
                                                {...register('active')}
                                                checked={isActiveChecked}
                                                onChange={handleIsActiveChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="submit" 
                            form="indentificatorForm" 
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? t('common.saving') : t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}